import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { IGetState } from '../../../../../../../../types/types';
import { hintHide } from '../../../../../../hints/effects/hintHide';
import { EHintKey } from '../../../../../../hints';
import { getActiveHint } from '../../../../../../hints/store/hints/selectors/getActiveHint';

export const onHideHint = (): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const activeHint = getActiveHint(getState());
        if (activeHint && activeHint.key === EHintKey.KANBAN_COLOR_TAGS_SCROLL_UP) {
            dispatch(hintHide(EHintKey.KANBAN_COLOR_TAGS_SCROLL_UP));
        }
    };
    return action;
};
